import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useTablesStyles } from './tables.styles';

export function SimpleTable({ className, ...rest }) {
  return <div className={className} {...rest} />;
}

export function SimpleTableHead({ className, ...rest }) {
  const { styles } = useTablesStyles();
  return (
    <div className={classNames(styles.simpleTableHead, className)} {...rest} />
  );
}

export function SimpleTableBody(props) {
  return <div {...props} />;
}

export function SimpleTableRow({ className, ...rest }) {
  const { styles } = useTablesStyles();
  return (
    <div className={classNames(styles.simpleTableRow, className)} {...rest} />
  );
}

export function SimpleTableCell({ className, children, textId, ...rest }) {
  const { styles } = useTablesStyles();
  return (
    <div className={classNames(styles.simpleTableCell, className)} {...rest}>
      {textId ? <FormattedMessage id={textId} /> : children}
    </div>
  );
}
